
<template>
  <div class="intro-bar">
    <div class="title-container">
      <div class="title-block">
        <div class="cost"><span class="currency">$</span>{{cost}}</div>
        <div class="name">{{name}}</div>
      </div>
      
      <div class="icon-block" v-bind:style="{ 'background': barColor }">
        <v-icon
          class="icon"
          color="white"
          size="57"
        >
          {{icon}}
        </v-icon>
      </div>
    </div>      

    <div class="bar-chart-container">
      <div class="bar-chart" v-bind:style="{ 'background': barFillColor, 'width': `${barWidth}%` }">
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'intro-bar',
  data () {
    return {
    }
  },

  props: [ 
    'icon',
    'cost',
    'name',
    'length',
    'color'
  ],

  methods: {
    lightenDarkenColor(colorCode, amount) {
      var usePound = false;

      if (colorCode[0] == "#") {
        colorCode = colorCode.slice(1);
        usePound = true;
      }

      var num = parseInt(colorCode, 16);

      var r = (num >> 16) + amount;

      if (r > 255) {
        r = 255;
      } else if (r < 0) {
        r = 0;
      }

      var b = ((num >> 8) & 0x00FF) + amount;

      if (b > 255) {
        b = 255;
      } else if (b < 0) {
        b = 0;
      }

      var g = (num & 0x0000FF) + amount;

      if (g > 255) {
        g = 255;
      } else if (g < 0) {
        g = 0;
      }

      return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }    
 },

  computed: {
    barColor() {
      return this.color
    },
    barFillColor() {
      let shadeColor = this.lightenDarkenColor(this.barColor, 20)
      return `repeating-linear-gradient(45deg,${this.barColor},${this.barColor} 10px, ${shadeColor} 10px, ${shadeColor} 20px)`;      

    },
    barWidth() {
      return this.length;
    }
  }
}

</script>


<style scoped>

.intro-bar {
  font-size: 10pt;
  width: 100%;
  height: 100px;
  text-align: center;
  position: relative;
}
.title-container {
  width: 190px;
  height: 100%;
  position: relative;
}
.title-block {
  width: 110px;
  background-color: white;
  height: 100%;
  padding-top: 15px;
}
.title-block .cost {
  font-size: 24pt;
}
.title-block .name {
  font-size: 9pt;
  color: #777;  
  line-height: 1.95ch;

}
.icon-block {
  position: absolute;
  width: 80px;
  height: 100%;
  right: 0px;
  top: 0px;
}
.currency {
  font-size: 10pt;
  vertical-align: top;  
}
.cost-container {
  width: 115px;
  background-color: yellow;
  height: 100%;
}
.cost {
  font-size: 22pt;
  color: black;
  font-weight: bold;
  
}
.cost-name {
  font-size: 12pt;
  color: black;    
}

.icon {
  margin: 0 auto;
  height: 100%;
}
.bar-chart-container {
  position: absolute;
  height: 100%;
  width: calc(100% - 205px);
  top: 0px;
  left: 205px;
}
.bar-chart {
  position: absolute;
  height: 100%;
  left: 0px;
  top: 0px;
  width: 100%;
  -webkit-box-shadow: 2px 3px 5px 0px rgba(0,0,0,0.4);
  -moz-box-shadow: 2px 3px 5px 0px rgba(0,0,0,0.4);
  box-shadow: 2px 3px 5px 0px rgba(0,0,0,0.4);
}
</style>